import { render } from "./bottom.vue?vue&type=template&id=6c27474b&scoped=true"
import script from "./bottom.vue?vue&type=script&lang=js"
export * from "./bottom.vue?vue&type=script&lang=js"

import "./bottom.vue?vue&type=style&index=0&id=6c27474b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6c27474b"

export default script